<script lang="ts">
	import { X } from 'lucide-svelte';

	type Props = {
		onclick?: () => void;
	};

	let { onclick }: Props = $props();
</script>

<button
	type="button"
	class="absolute top-5 right-5 hover:text-primary transition-colors duration-200 ease-in-out"
	{onclick}
>
	<X size={20} />
</button>
